import list from './list'
import dashboardList from './dashboardList'
import progress from './progress'
import details from './details'
import run from './run'
import summary from './summary'
import mapping from './mapping'
import active from './active'
import approveEmployeeImport from './approveEmployeeImport'
import cancelEmployeeImport from './cancelEmployeeImport'

export default {
  list,
  dashboardList,
  progress,
  details,
  run,
  summary,
  mapping,
  active,
  approveEmployeeImport,
  cancelEmployeeImport,
}
